// TODO: remove with https://github.com/combinaut/sparkle/issues/32203 once admin JS imports sp apps directly.
/** Matches the selects whose value the add-to-url behaviour writes into its target link. */
export const ADD_TO_URL_SELECTS =
  'select[data-sparkle-action~="add-to-url"], sp-select[data-sparkle-action~="add-to-url"]';

/** Returns the value an add-to-url select writes into its target link. */
export function addToUrlSelectValue(control) {
  return control.value;
}
